<ng-container *ngIf="buttonLabel">
	<div class="add-to-cart-field">
		<input
			class="copo-offer-text-align-right add-to-cart-input"
			matInput
			copoInputNumber
			type="number"
			[formControl]="numberControl"
			[min]="1"
			[decimalCount]="0"
			value="1"
			/>
		<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"></mat-icon>
	</div>
	<button type="button" class="add-to-cart-btn" mat-flat-button color="primary"
	(click)="addToCart()">
		<span class="add-to-cart-btn-name">{{ buttonLabel }}</span>
	</button>
</ng-container>